var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.6 55.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f78e31;}.cls-2{fill:#f5bd89;}.cls-3{fill:#f7a85c;}.cls-4{fill:#f5ecd7;}.cls-5{fill:#f48e32;}.cls-6{fill:#f4bf88;}.cls-7{fill:#f6d6b7;}.cls-8{fill:#ef9130;}.cls-9{fill:#808285;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.64,
    width: 3.17,
    height: 3.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.53,
    y: 3.01,
    width: 3.17,
    height: 3.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 77.59,
    y: 6.05,
    width: 3.17,
    height: 3.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 80.77,
    y: 9.23,
    width: 3.17,
    height: 3.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 80.77,
    y: 12.4,
    width: 3.17,
    height: 3.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 77.59,
    y: 12.4,
    width: 3.17,
    height: 3.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 74.42,
    y: 9.23,
    width: 3.17,
    height: 3.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 71.25,
    y: 12.4,
    width: 3.17,
    height: 3.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.46,19.27a7.13,7.13,0,1,1,0,14.24,7.13,7.13,0,1,1,0-14.24Zm0,11.5a4.38,4.38,0,1,0,0-8.76,4.38,4.38,0,1,0,0,8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.31,19.63h2.91v1.71h.05a4.77,4.77,0,0,1,4.14-2.07A5.42,5.42,0,0,1,29.66,25v8.16H26.75V25.64c0-2.46-1.28-3.47-3.21-3.47a3.16,3.16,0,0,0-3.32,3.41v7.57H17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.83,19.63h1.65V16.06l2.91-.81v4.38H38.7v2.74H36.39V27.7c0,1.45.33,2.12,1.2,2.63l1.56.89-1.28,2.29c-3-1.42-4.39-2.46-4.39-5.28V22.37H31.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54,30.22a8.22,8.22,0,0,1-6.29,3.29,7.13,7.13,0,1,1,0-14.24,7.27,7.27,0,0,1,7,7.59v.53H43.51a4.06,4.06,0,0,0,4.13,3.55,4.81,4.81,0,0,0,3.91-2.09ZM51.33,25a4.07,4.07,0,0,0-4-3.15A3.82,3.82,0,0,0,43.51,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.32,15.61V27.7c0,1.57.33,2.12,1.2,2.63l1.56.89L61.8,33.51c-3-1.42-4.39-2.46-4.39-5.28V15.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.3,15.61V27.7c0,1.57.33,2.12,1.2,2.63l1.56.89-1.28,2.29c-3-1.42-4.39-2.46-4.39-5.28V15.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.32,19.63h2.9V27.2a3.27,3.27,0,1,0,6.54,0V19.63h2.9v7.82a6.17,6.17,0,0,1-12.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.77,29.13a6.26,6.26,0,0,0,4.24,2c1.68,0,2.68-.95,2.68-1.7S94,28,92.93,27.84l-1.64-.31c-3.8-.69-4.86-1.92-4.86-3.85,0-2.29,1.92-4.41,5.3-4.41a8.83,8.83,0,0,1,5.36,1.87l-1.64,2a5.6,5.6,0,0,0-3.63-1.51c-1.26,0-2.49.61-2.49,1.7,0,.81.64,1.23,1.76,1.43l2.93.56c2.4.44,3.58,1.59,3.58,3.6S96,33.51,91.87,33.51a9.08,9.08,0,0,1-6.08-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,35.51H3.05L6.59,44.8l3.57-8.44,3.62,8.44,3.49-9.29h3.07l-6.56,16-3.62-9.08L6.39,51.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.73,38.78a6.37,6.37,0,1,1,0,12.73,6.37,6.37,0,1,1,0-12.73Zm0,10.29a3.92,3.92,0,1,0-3.92-3.92A3.85,3.85,0,0,0,26.73,49.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.79,39.11h2.45v1.32h0a2.62,2.62,0,0,1,3.79-1.27l-.92,2.57a1.92,1.92,0,0,0-1-.35,1.78,1.78,0,0,0-1.8,1.82v8h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.06,46.15h-1.7V43.7h1.7V35.51h2.59V43.7H48l3.17-4.59h3.15L50.2,44.8l4.29,6.39H51.42l-3.2-5H46.65v5H44.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.81,44.05h-1.7V41.6h1.7v-2a4.15,4.15,0,0,1,4.49-4.37h.3v2.44c-1.57,0-2.19.88-2.19,1.78V41.6h3.42V35.51h2.59V46.2c0,1.39.3,2,1.08,2.47l1.39.8-1.14,2c-2.68-1.27-3.92-2.19-3.92-4.71V44.05H59.41V55.36h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75,38.78a6.37,6.37,0,1,1-6.66,6.37A6.39,6.39,0,0,1,75,38.78Zm0,10.29a3.92,3.92,0,1,0-3.92-3.92A3.85,3.85,0,0,0,75,49.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.57,39.11h2.8l2.14,6.54h0l2.52-5.79,2.52,5.79h.05l2.15-6.54h2.8l-4.67,12.4L90.11,45h0l-2.82,6.54Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.408a027646cbf05ff8fc4588c3e55c4e.svg";
export { ForwardRef as ReactComponent };